"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENVIRONMENT_TYPE = void 0;
exports.ENVIRONMENT_TYPE = {
    PREVIEW: 'PREVIEW',
    PRODUCTION: 'PRODUCTION'
};
//# sourceMappingURL=environmentType.js.map